
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#00BD90"}},[_c('path',{attrs:{"d":"M17.608 18.177a.667.667 0 00-.275-.71 10.657 10.657 0 01-4.632-8.01.667.667 0 00-.778-.608 5.12 5.12 0 00-2.487 1.17.667.667 0 01-.872 0A5.15 5.15 0 005.18 8.76C2.276 8.759 0 11.507 0 15.013a10.4 10.4 0 002.112 6.782.667.667 0 01.115.644 15.381 15.381 0 00-.839 5.074 15.965 15.965 0 00.327 3.23A1.583 1.583 0 003.259 32a1.614 1.614 0 001.608-1.441C5.209 27.42 6.985 25.056 9 25.056s3.79 2.365 4.133 5.504A1.615 1.615 0 0014.741 32a1.583 1.583 0 001.544-1.257 15.96 15.96 0 00.327-3.23 15.373 15.373 0 00-.839-5.074.668.668 0 01.112-.643 8.998 8.998 0 001.723-3.619zM23.333 0A8.666 8.666 0 1032 8.667 8.677 8.677 0 0023.333 0zm4.632 7.139l-3.873 5.166a2.335 2.335 0 01-3.52.247l-2-2a1.334 1.334 0 011.887-1.885l1.186 1.186a.667.667 0 001.006-.07l3.181-4.243a1.333 1.333 0 112.133 1.6v-.001z"}})])])
          )
        }
      }
    